<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre2"> <span class="calibre3"> </span> </p>
<p class="calibre4"> <span class="calibre3"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre4"> <span class="calibre5"> </span> </p>
<p class="calibre6"> <span class="calibre5">Willow’s Flame</span> </p>
<p class="calibre6"> <span class="calibre3"> </span> </p>
<p class="calibre6"> <span class="calibre3">Do You Really Know Who You're Sleeping Next To?</span> </p>
<p class="calibre6"> <span class="calibre3"> </span> </p>
<p class="calibre6"> <span class="calibre7"> </span> </p>
<p class="calibre8"> <span class="calibre7">Stephanie Fields</span> </p>
<p class="calibre2"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0000.vue?6e8eea8a